// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"b55a0d4c","194":"e8b196d7","311":"2dafff48"}[chunkId] + ".chunk.js";
};